<template>
	<div class="col-md-12">
		<!-- <p>
			<b>Total Error Count:</b> {{aErrors.length}} &nbsp;&nbsp;&nbsp; <a class="btn-sm btn-danger" @click="clearErrors(error)">Clear Errors</a>
		</p>
		<div class="table-responsive">
			<table class="table error-table">
				<tr>
					<th>Options</th>
					<th class="date">Timestamp</th>
					<th class="status">Status</th>
					<th class="type">Type</th>
					<th class="message">Message</th>
					<th class="route">Route</th>
				</tr>
				<tr v-for="error in aErrors">
					<td><a type="button" class="btn-sm btn-primary" @click="setCurrentError(error)" data-toggle="modal" data-target=".bd-example-modal-lg">Details</a></td>
					<td>{{ error.response.headers.date | convertDate }}</td>
					<td>{{error.response.status}} - {{error.response.statusText}}</td>
					<td>{{error.response.data.type}}</td>
					<td>
						<span v-if="error.response.data.hasOwnProperty('message')">{{error.response.data.message}}</span>
						<span v-if="error.response.data.hasOwnProperty('messages')">{{error.response.data.messages[0]}}</span>
					</td>
					<td>{{error.response.config.url}}</td>
				</tr>
			</table>
		</div>
		<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" v-if="currentError.hasOwnProperty('response')">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						<h4 class="modal-title">{{currentError.response.data.timestamp}} - {{currentError.response.data.message}}</h4>
					</div>
					<div class="modal-body">
						<vue-json-pretty :data="currentError"></vue-json-pretty>
					</div>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	// import VueJsonPretty from 'vue-json-pretty';
	import moment from 'moment';

	export default {
		data() {
			return {
				currentError: {}
			};
		},
		// components: {
		// 	VueJsonPretty
		// },
		computed: mapState({
			aErrors: state => state.aErrors
		}),
		filters:{
			convertDate(value) {
				return moment(String(value)).format('MM/DD/YYYY h:mm:ss a');
			}
		},
		methods:{
			setCurrentError(error) {
					this.currentError = error
			},
			handleJSONClick() {

			},
			clearErrors() {
					this.$store.commit('clearErrors');
			}
		},
		beforeCreate() {
				this.$store.commit('updatePageTitle',  'Error Logs' );
		},
	}
</script>

<style>
	.error-table tr td, .error-table tr th {
		padding: 10px 5px;
	}

	.error-table tr td {
		border-bottom: 1px solid #EEE;
	}

	.error-table tr th {
		border-bottom: 3px solid #EEE;
	}

	.error-table tr th.message {
		min-width: 350px;
	}

	.error-table tr th.status, .error-table tr th.date, .error-table tr th.type {
		min-width: 200px;
	}

	.error-table tr th.route {
		min-width: 500px;
	}
</style>
